import React from 'react';
import { orders } from '../data/orders.js';
import { judgments } from '../data/judgments.js';
import CarouselSwiper from '../services/CarouselSwiper.jsx';
import '../styles/minute.css';
import '../styles/carousel.css';

const Domestic = () => {

    return (
        <div className="justified-text">
            <h5>Decisions of domestic courts</h5>
            <p>
                These are orders and transcripts of judgments by domestic courts
            </p>
            <h5>1. Orders</h5>
            <div>
                <br/>
                <CarouselSwiper images={orders} />
            </div>    
            <h5>2. Transcripts of judgments</h5>
            <div>
                <br/>
                <CarouselSwiper images={judgments} />
            </div>  
        </div>
    );
};

export default Domestic;

